const Uppy = require('@uppy/core')
const Dashboard = require('@uppy/dashboard')
const AwsS3 = require('@uppy/aws-s3')
const ptBR = require('@uppy/locales/lib/pt_BR')

import Rails from "@rails/ujs"

require('@uppy/core/dist/style.css')
require('@uppy/dashboard/dist/style.css')

var gallery_uploader = gallery_uploader || {};

gallery_uploader = (function ($) {
  'use strict';

  let uppy

  function init() {
    const container = $('.gallery-uploader-container')
    if (container.length === 0) return

    const form = $(`#${container.data('form-id')}`)
    const submitButton = form.find('.btn-upload-and-submit')
    const dismissButtons = form.find('[data-dismiss="modal"]')
    const modalContent = form.closest('.modal-content')
    const modal = form.closest('.modal')
    const maxUploadMb = parseFloat(container.data('max-upload-mb'))
    const maxUploadBytes = Number.isFinite(maxUploadMb) && maxUploadMb > 0 ? maxUploadMb * 1024 * 1024 : null
    const initialGalleryImageId = container.data('gallery-image-id') || null
    let galleryImageId = initialGalleryImageId
    let signUrlQueue = Promise.resolve()

    const setModalActionsEnabled = (enabled) => {
      submitButton.prop('disabled', !enabled)
      dismissButtons.prop('disabled', !enabled)
    }

    const showLoading = (message) => {
      setModalActionsEnabled(false)

      if (modalContent.length === 0) return

      modalContent.addClass('position-relative')

      if (modalContent.find('.gallery-upload-loading').length === 0) {
        modalContent.append(`
          <div class="gallery-upload-loading position-absolute w-100 h-100 d-flex align-items-center justify-content-center bg-white" style="top: 0; left: 0; opacity: 0.9; z-index: 1050;">
            <div class="text-center">
              <span class="spinner-border text-primary" role="status" aria-hidden="true"></span>
              <div class="gallery-upload-loading-message mt-2">${message}</div>
            </div>
          </div>
        `)
      } else {
        modalContent.find('.gallery-upload-loading-message').text(message)
      }
    }

    const hideLoading = () => {
      modalContent.removeClass('position-relative')
      modalContent.find('.gallery-upload-loading').remove()
      setModalActionsEnabled(true)
    }

    const showMaxUploadAlert = (fileName) => {
      const limitText = Number.isFinite(maxUploadMb) && maxUploadMb > 0 ? `${maxUploadMb}MB` : 'o limite permitido'
      const fileLabel = fileName ? `"${fileName}" ` : ''

      alert(`O arquivo ${fileLabel}ultrapassa ${limitText}.`)
    }

    const ensureGalleryImageIdField = (value) => {
      let field = form.find('input[name="gallery_image[gallery_image_id]"]')

      if (field.length === 0) {
        field = $('<input>', {
          type: 'hidden',
          name: 'gallery_image[gallery_image_id]'
        }).appendTo(form)
      }

      field.val(value)
      galleryImageId = value
    }

    const resetUploadSession = () => {
      galleryImageId = initialGalleryImageId
      form.find('input[name="gallery_image[gallery_image_id]"]').remove()
      form.find('input[name="gallery_image[uppy_gallery_assets][]"]').remove()

      if (initialGalleryImageId) {
        ensureGalleryImageIdField(initialGalleryImageId)
      }

      signUrlQueue = Promise.resolve()
    }

    const submitFormWithUploadResults = (result) => {
      form.find('input[name="gallery_image[uppy_gallery_assets][]"]').remove()

      $('<input>', {
        type: 'hidden',
        name: 'gallery_image[uppy_gallery_assets][]',
        value: JSON.stringify(result)
      }).appendTo(form)

      if (galleryImageId) {
        ensureGalleryImageIdField(galleryImageId)
      }

      showLoading('Validando...')
      Rails.fire(document.querySelector(`#${container.data('form-id')}`), 'submit')
    }

    const parseJsonResponse = async (response) => {
      const body = await response.text()
      let data = {}

      try {
        data = body ? JSON.parse(body) : {}
      } catch (_error) {
        throw new Error('Não foi possível preparar o upload.')
      }

      if (!response.ok) {
        throw new Error(data.error || 'Não foi possível preparar o upload.')
      }

      return data
    }

    form.off('ajax:complete.galleryUploader ajax:error.galleryUploader')
    form.on('ajax:complete.galleryUploader', function () {
      hideLoading()
      uppy.reset()
      resetUploadSession()
    })
    form.on('ajax:error.galleryUploader', function () {
      hideLoading()
      uppy.reset()
      resetUploadSession()
      alert('Não foi possível salvar. Tente novamente.')
    })

    if (modal.length) {
      modal.off('show.bs.modal.galleryUploader')
      modal.on('show.bs.modal.galleryUploader', resetUploadSession)
    }

    uppy = new Uppy({
      id: `uppy_gallery_${container.data('form-id')}`,
      debug: true,
      locale: ptBR,
      onBeforeUpload: () => form.valid()
    })

    uppy.use(Dashboard, {
      inline: true,
      hideUploadButton: true,
      target: container.get(0),
      height: 120,
      width: '100%'
    })

    uppy.use(AwsS3, {
      timeout: 600_000,
      getUploadParameters(file) {
        const csrfToken = document.head.querySelector("[name='csrf-token']")

        signUrlQueue = signUrlQueue.then(() => {
          return fetch('/aws/sign-url', {
            method: 'post',
            headers: {
              accept: 'application/json',
              'content-type': 'application/json',
              'X-CSRF-Token': csrfToken.content
            },
            body: JSON.stringify({
              gallery_id: container.data('gallery-id'),
              gallery_image_id: galleryImageId,
              description: form.find('[name="gallery_image[description]"]').val(),
              file: {
                name: file.name,
                type: file.type,
                size: file.size
              }
            })
          }).then((response) => parseJsonResponse(response).then((data) => {
            if (data.gallery_image_id) {
              ensureGalleryImageIdField(data.gallery_image_id)
            }

            return {
              method: data.method,
              url: data.url,
              fields: data.fields,
              headers: {
                'content-type': data.headers.content_type,
                'x-amz-acl': data.headers.acl
              }
            }
          }))
        })

        return signUrlQueue
      }
    })

    uppy.on('file-added', (file) => {
      if (!maxUploadBytes || (file.size || 0) <= maxUploadBytes) return

      uppy.removeFile(file.id)
      showMaxUploadAlert(file.name)
    })

    uppy.on('upload', () => {
      setModalActionsEnabled(false)
    })

    uppy.on('upload-error', (_file, error) => {
      setModalActionsEnabled(true)

      if (error && error.message) {
        alert(error.message)
      }
    })

    uppy.on('complete', (result) => {
      if (result.successful.length > 0) {
        if (result.failed.length > 0) {
          alert('Ocorreu um erro ao enviar o(s) arquivo(s). Os arquivos enviados com sucesso serão salvos.')
        }

        submitFormWithUploadResults(result)
        return
      }

      if (result.failed.length > 0) {
        setModalActionsEnabled(true)
        alert('Ocorreu um erro ao enviar o(s) arquivo(s). Tente novamente.')
        return
      }

      setModalActionsEnabled(true)
    })

    submitButton.off('click.galleryUploader')
    submitButton.on('click.galleryUploader', function (event) {
      event.preventDefault()

      if (uppy.getFiles().length > 0) {
        uppy.upload()
      } else {
        showLoading('Salvando...')
        Rails.fire(document.querySelector(`#${container.data('form-id')}`), 'submit')
      }
    })
  }

  return {
    init: init
  };
})(jQuery);

document.addEventListener("turbolinks:load", function () {
  gallery_uploader.init()
})

document.addEventListener("turbolinks:before-cache", function () {
  $('.gallery-uploader-container').empty()
})
